import React from 'react';
import { useProviderEditModel } from './useProviderEditModel';
import utilSvc from '../../../../core/utilSvc';

type ChangeProperty = {
    Changed: string;
    Name: string;
    OldValue: string | null;
};

export type ChangeEntry = {
    Id: string;
    Action: string;
    ChangedProperties: ChangeProperty[];
    ModBy: string;
    ModDt: string;
    Note: string;
};

const ProviderEditChangeHistoryTab = (): JSX.Element => {
    const { model } = useProviderEditModel();
    const { ChangeLog } = model;

    return (
        <div className="provider-edit-change-history-tab">
            <p className="change-history-caption">
                Viewing changes in <strong>descending order by date</strong>.
            </p>
            {ChangeLog ? (
                ChangeLog.toReversed().map((changeEntry: ChangeEntry) => (
                    <ChangeEntry
                        key={changeEntry.ModDt}
                        entry={changeEntry}
                    />
                ))
            ) : (
                <p>No change history available.</p>
            )}
        </div>
    );
};

export default ProviderEditChangeHistoryTab;

const ChangeEntry = ({ entry }: { entry: ChangeEntry }): JSX.Element => {
    // unicode for non breaking space
    const nbsp = '\u00A0';
    const entries = entry.ChangedProperties;

    return entries.length === 0 ? (
        <></>
    ) : (
        <div className="change-entry">
            <p className="change-entry-title">
                {utilSvc.dt.toTextWithTime(entry.ModDt)}
                {nbsp}
                {nbsp}|{nbsp}
                {nbsp}Changed By: {entry.ModBy}
            </p>
            {entry.ChangedProperties.map((prop, idx) => {
                const changed = prop.Changed === null ? 'unassigned' : prop.Changed;
                return (
                    <div
                        key={`${prop.Name}-${idx}`}
                        className="change-property"
                    >
                        <p>
                            <strong>{prop.Name}</strong>: {buildEntryValue(changed)}
                        </p>
                    </div>
                );
            })}
        </div>
    );
};

const buildEntryValue = (val: string): string => {
    const value = val.split(' => ');
    if (value[0] === '') {
        return value[value.length - 1];
    }
    return `${value[0]} => ${value[1]}`;
};
